import { mapState } from 'vuex';
export default {
  name: 'AlertsAssignee',
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      assignees: state => state.alerts.assignees
    }),
    assignee() {
      const match = this.assignees.find(item => item.id === this.modelValue?.id);
      if (!match) return this.modelValue || {};
      return {
        ...match,
        name: this.modelValue.name || match.name
      };
    }
  },
  methods: {
    onClick(val) {
      this.$emit('update:modelValue', val);
    }
  }
};